(() => {
  if (window.dsDeferredCollectionVariants) return;
  window.dsDeferredCollectionVariants = true;

  function showImage(card, wrapper) {
    card.querySelectorAll('.ds-product-item__image--two').forEach(image => {
      const active = image === wrapper;
      image.classList.toggle('active', active);
      image.style.opacity = active ? '1' : '0';
    });
    const defaultImage = card.querySelector('.product-item__image--one img');
    if (defaultImage) defaultImage.style.opacity = wrapper ? '0' : '1';
  }

  function selectImage(card, variantId) {
    const template = card.querySelector(`template[data-collection-variant-image="${variantId}"]`);
    if (!template) {
      showImage(card, null);
      return;
    }

    const imageId = template.dataset.imageId;
    let wrapper = card.querySelector(`[data-collection-image-id="${imageId}"]`);
    let image;
    const reveal = () => {
      if (card.dataset.selectedVariantId === variantId) showImage(card, wrapper);
    };
    const fallback = () => {
      if (card.dataset.selectedVariantId === variantId) showImage(card, null);
      wrapper.remove();
    };

    if (!wrapper) {
      const fragment = document.importNode(template.content, true);
      wrapper = fragment.querySelector('.ds-product-item__image--two');
      image = wrapper?.querySelector('img');
      if (!image) {
        showImage(card, null);
        return;
      }
      wrapper.dataset.collectionImageId = imageId;
      image.loading = 'eager';
      waitForImage();
      card.querySelector('.product-item__image-link').append(fragment);
    } else {
      image = wrapper.querySelector('img');
      if (image.complete && image.naturalWidth > 0) reveal();
      else waitForImage();
    }

    function waitForImage() {
      const loaded = () => {
        cleanup();
        reveal();
      };
      const failed = () => {
        cleanup();
        fallback();
      };
      const cleanup = () => {
        image.removeEventListener('load', loaded);
        image.removeEventListener('error', failed);
      };
      image.addEventListener('load', loaded, { once: true });
      image.addEventListener('error', failed, { once: true });
    }
  }

  function updateVariant(card, variantId) {
    card.dataset.selectedVariantId = variantId;
    card.querySelectorAll('.ds-product-item-options [data-variant]').forEach(item => {
      item.classList.toggle('ds-active', item.dataset.variant === variantId);
    });
    selectImage(card, variantId);

    card.querySelectorAll('a[href*="/products/"]').forEach(link => {
      if (link.closest('.product-item-options')) return;
      const url = new URL(link.href);
      url.searchParams.set('variant', variantId);
      link.href = url.toString();
    });

    const form = card.querySelector('.product-form');
    if (form) {
      const input = form.querySelector('input[name="id"]');
      if (input) input.value = variantId;
      form.dataset.currentProductId = variantId;
      const button = form.querySelector('.ds-custom-atc-button');
      if (button) button.dataset.variantAtcId = variantId;
    }

    const prices = card.querySelector('[data-variant-prices]');
    const variantPrice = prices?.querySelector(`[data-variant-id="${variantId}"]`);
    if (!variantPrice) return;
    const price = Number(variantPrice.dataset.price);
    const comparePrice = Number(variantPrice.dataset.comparePrice);
    const priceElement = prices.querySelector('[data-price-element]');
    const compareElement = prices.querySelector('[data-compare-price-element]');
    const format = value => new Intl.NumberFormat('de-DE', {
      style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2
    }).format(value / 100).replace(/\s/g, '');
    if (priceElement) {
      priceElement.textContent = format(price);
      priceElement.className = comparePrice > price ? 'sale ds-colored-price' : 'product-item__price';
    }
    if (compareElement) {
      compareElement.textContent = comparePrice > price ? format(comparePrice) : '';
      compareElement.style.display = comparePrice > price ? '' : 'none';
    }
  }

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const item = event.target.closest('.ds-product-item-options .product-item-options__item--swatch[data-variant]');
    const card = item?.closest('[data-deferred-variant-images]');
    if (!card) return;
    event.preventDefault();
    updateVariant(card, item.dataset.variant);
  });
})();
